<template>
  <div>
    <v-card>

      <v-card-title class='justify-center' style='background-color: #e6e6e6;'>
        <v-icon left>school</v-icon>
        Ação/Conteúdo
      </v-card-title>

      <v-card-text>

        <v-data-table
            v-model='anosEscolaresSelecionados'
            :headers='headers'
            :items='anosEscolares'
            :loading='carregandoDados'
            :footer-props="footerProps"
            item-key='id'
            class='elevation-1'
        >
          <template v-slot:top>

            <v-row style='margin-top: 10px;'>

              <v-col cols='2'>
                <v-select
                    @change="filtrar()"
                    v-model='anoSelecionado'
                    :items='anos'
                    label='Ano'
                    no-data-text='Nenhum ano escolar encontrado'
                    dense
                    outlined
                ></v-select>
              </v-col>

              <v-col cols='2'>
                <v-select
                    @change="filtrar()"
                    v-model='turmaSelecionada'
                    :items='turmas'
                    label='Turma'
                    no-data-text='Nenhuma turma encontrada'
                    dense
                    outlined
                ></v-select>
              </v-col>

              <v-col cols='2'>
                <v-select
                    @change="filtrar()"
                    v-model='disciplinaSelecionada'
                    :items='disciplinas'
                    label='Disciplina'
                    no-data-text='Nenhuma disciplina encontrada'
                    dense
                    outlined
                ></v-select>
              </v-col>

              <v-col cols='2'>
                <v-select
                    @change="filtrar()"
                    v-model='escolaSelecionada'
                    :items='escolas'
                    label='Escola'
                    no-data-text='Nenhuma escola encontrada'
                    dense
                    outlined
                ></v-select>
              </v-col>

            </v-row>

          </template>

          <template v-slot:item.action="{ item }">

            <v-tooltip bottom v-if="showBtn(['Diretor', 'Administrador'])">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" class="white--text">
                  <v-icon color="blue" @click="enviarAtividadeUmAno(item)">mdi-file-upload-outline</v-icon>
                </v-btn>
              </template>
              <span>Enviar Atividade</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" class="white--text">
                  <v-icon color="green" @click="abrirListaDeAtividades(item)">mdi-format-list-checkbox</v-icon>
                </v-btn>
              </template>
              <span>Atividades</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-snackbar
        absolute
        v-model="snackbar.active"
        :color="snackbar.color"
        :top="true"
    >
      {{snackbar.message}}
      <v-btn dark text @click="snackbar.active = false">
        Fechar
      </v-btn>
    </v-snackbar>

    <EnviarAtividade
        :show="showEnviarAtividades"
        :anos-para-enviar="anosParaEnviar"
        :fechar="fecharEnviarAtividade"
    />

    <ListaAtividades
        :show="showListaAtividades"
        :ano-escolar="anoDaLista"
        :fechar="fecharListaDeAtividades"
    />

  </div>
</template>

<script>

import PlanejamentoAcaoService from '@/service/PlanejamentoAcaoService';
import _ from 'lodash';
import EnviarAtividade from "@/views/PlanejamentoAcao/EnviarAtividade";
import ListaAtividades from "@/views/PlanejamentoAcao/ListaAtividades";
import {mapGetters} from "vuex";

export default {
  components: {ListaAtividades, EnviarAtividade},
  data() {
    return {
      //raiz
      carregandoDados: false,
      todosAnosEscolares: [],
      anosEscolares: [],
      anosEscolaresSelecionados: [],
      disciplinas: [],
      disciplinaSelecionada: 'Todas',
      escolas: [],
      escolaSelecionada: 'Todas',
      anos: [],
      anoSelecionado: 'Todos',
      turmas: [],
      turmaSelecionada: 'Todas',
      footerProps: {
        itemsPerPageText: "Itens por página:",
        itemsPerPageOptions: [10, 20, 50]
      },
      headers: [
        {
          text: 'Ano',
          value: 'ano',
          align: 'center'
        },
        {
          text: 'Disciplina',
          value: 'disciplina',
          align: 'center'
        },
        // {
        //   text: 'Escola',
        //   value: 'escola',
        //   align: 'center'
        // },
        {
          text: '#',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      snackbar: {
        message: "",
        color: "",
        active: ""
      },

    //  enviar atividades
      showEnviarAtividades: false,
      anosParaEnviar: [],

    //  Lista atividades
      showListaAtividades: false,
      anoDaLista: {}
    }
  },

  computed: {
    ...mapGetters({
      user: 'Login/user'
    })
  },

  methods: {

    showBtn(item) {
      return item.includes(this.user ? this.user.perfil : '');
    },

    //lista de atividades
    fecharListaDeAtividades() {
      this.showListaAtividades = false;
    },

    //enviar atividade
    fecharEnviarAtividade() {
      this.showEnviarAtividades = false;
    },

    //raiz
    abrirListaDeAtividades(item) {
      this.anoDaLista = item;
      this.showListaAtividades = true;
    },

    enviarAtividadeUmAno(item) {
      this.anosParaEnviar = [];
      this.anosParaEnviar.push(item);
      this.showEnviarAtividades = true;
    },

    enviarAtividadeParaMultiplosAnos() {
      this.anosParaEnviar = [];
      this.anosParaEnviar = JSON.parse(JSON.stringify(this.anosEscolaresSelecionados));
      this.showEnviarAtividades = true;
    },

    filtrar() {

      let self = this;

      this.anosEscolares = JSON.parse(JSON.stringify(this.todosAnosEscolares));

      this.anosEscolares = _.filter(this.anosEscolares, function (anoEscolar) {

        if (self.anoSelecionado !== 'Todos' && !anoEscolar.ano.includes(self.anoSelecionado))
          return false;

        if (self.turmaSelecionada !== 'Todas' && !anoEscolar.ano.includes(self.turmaSelecionada))
          return false;

        if (self.disciplinaSelecionada !== 'Todas' && anoEscolar.disciplina !== self.disciplinaSelecionada)
          return false;

        return !(self.escolaSelecionada !== 'Todas' && anoEscolar.escola !== self.escolaSelecionada);

      });

      this.anosEscolaresSelecionados = _.filter(this.anosEscolaresSelecionados, function (anoEscolar) {

        if (self.anoSelecionado !== 'Todos' && !anoEscolar.ano.includes(self.anoSelecionado))
          return false;

        if (self.turmaSelecionada !== 'Todas' && !anoEscolar.ano.includes(self.turmaSelecionada))
          return false;

        if (self.disciplinaSelecionada !== 'Todas' && anoEscolar.disciplina !== self.disciplinaSelecionada)
          return false;

        return !(self.escolaSelecionada !== 'Todas' && anoEscolar.escola !== self.escolaSelecionada);

      });
    },

    setDisciplinas() {
      this.disciplinas = _.map(this.anosEscolares, 'disciplina')
      this.disciplinas.unshift('Todas')
    },

    setEscolas() {
      this.escolas = _.map(this.anosEscolares, 'escola')
      this.escolas.unshift('Todas')
    },

    setAnos() {
      let self = this;
      this.anos = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
      this.anos = _.filter(this.anos, function (ano) {
        for (let i = 0; i < self.anosEscolares.length; i++)
          if (self.anosEscolares[i].ano.includes(ano))
            return true;
        return false;
      })
      this.anos.unshift('Todos')
    },

    setTurmas() {
      let self = this;
      this.turmas = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']
      this.turmas = _.filter(this.turmas, function (turma) {
        for (let i = 0; i < self.anosEscolares.length; i++)
          if (self.anosEscolares[i].ano.includes(turma))
            return true;
        return false;
      })
      this.turmas.unshift('Todas')
    }
  },

  created() {

    this.carregandoDados = true;

    PlanejamentoAcaoService.getAll()
        .then(({data}) => {
          this.anosEscolares = data;
          this.todosAnosEscolares = JSON.parse(JSON.stringify(this.anosEscolares));
          this.setDisciplinas();
          this.setEscolas();
          this.setAnos();
          this.setTurmas();
        })
        .catch(() => {
          console.error('Error!')
        })
        .finally(() => {
          this.carregandoDados = false;
        })
  }
}
</script>